import { render, staticRenderFns } from "./GroupLinkUsersDialog.vue?vue&type=template&id=b9ec2fea&scoped=true"
import script from "./GroupLinkUsersDialog.vue?vue&type=script&lang=js"
export * from "./GroupLinkUsersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ec2fea",
  null
  
)

export default component.exports